import React from 'react'

import VectorTileLayer from 'ol/layer/VectorTile'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'

import type { Options as VectorTileOptions } from 'ol/layer/VectorTile'

import * as PoziUtils from 'api/utils'
import type { ConfigLayerOptions } from 'config/ConfigLayer'
import { MapLayer } from 'config/MapLayer'
import VectorTile from 'config/VectorTile'
import { setLayerLoadDone } from 'drawer/tabs/layers/actions'

export interface ConfigLayerVectorTileOptions extends VectorTileOptions {
  title: string
  titleid: string
  group: string
}

export class MapLayerVectorTile extends MapLayer {
  static createLayer (layerConf: ConfigLayerOptions): VectorTileLayer {
    this.preLayer(layerConf)

    // Must define the base olLayer here instead of in the react component for legacy reasons (model/history/info panel/etc)
    const vectorTileOptions: ConfigLayerVectorTileOptions = {
      title: layerConf.title,
      titleid: layerConf.titleid,
      group: layerConf.group,
      opacity: layerConf.opacity || 1,
      maxResolution: layerConf.maxResolution || 100000,
      minResolution: layerConf.minResolution || 0.0001,
      visible: PoziUtils.isLayerSelected(layerConf, true),
      declutter: true
    }
    const olLayer = new VectorTileLayer(vectorTileOptions)

    const olSourceVectorTile = olLayer.getSource()

    if (olSourceVectorTile) {
      // Hack to mark layer as loaded once 1 tile has successfully loaded
      olSourceVectorTile.once('tileloadend', () => {
        window.store.dispatch(setLayerLoadDone(layerConf.titleid))
      })
    }

    const layerConfigElement = document.getElementById('layerConfig')
    const newElement = document.createElement('div')
    newElement.id = layerConf.title
    if (layerConfigElement) {
      layerConfigElement.appendChild(newElement)
    }

    createRoot(newElement).render(
      <Provider store={window.store}>
        <VectorTile olLayer={olLayer} layerConf={layerConf} titleid={layerConf.titleid} bMapLoaded={false}/>
      </Provider>
    )

    return olLayer
  }
}
